import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';

export default function Comp() {
    const { useLang } = useGlobal();
    const { t } = useLang('smarthomepanel');

    return (
        <div className={`${css.gsapB} gsapB1`}>
            <div className="msg-box msg-trigger1">
                <div className="msg-line1">{t('smart_home_panel.seven_title')}</div>
                <div className="msg-line2">{t('smart_home_panel.seven_subtitle')}</div>
                <div className="msg-line3">
                    {t('smart_home_panel.seven_subtitle_white')} <span className="msg-color1">{t('smart_home_panel.seven_subtitle_other')}</span>
                </div>
            </div>
            <div className="img-box">
                <div className="video-trigger">
                    <EFVideo sources={['/video/smarthomepanel/video1.webm', '/video/smarthomepanel/video1.mp4']} className="video" />
                </div>
                <div className="video-tips msg-trigger2">
                    <span className="video-color1">{t('smart_home_panel.seven_des_white')}</span>
                    <span className="video-color2">{t('smart_home_panel.seven_des_gray')}</span>
                </div>
            </div>
        </div>
    );
}
